import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { reverse, forEach, map, join, filter } from 'lodash';
import Loading from '../Loding/Loading';
import MobileLineItem from './MobileLineItem';
import MobileLineList from './MobileLineList';

import { products } from '../../services';
import { NoService } from '.'
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';

const mobileCategories = ['MOBILE', 'PREPAYE', 'CACHER', 'MOBILE MVNO'];

class MobileLine extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const {
      setProducts,
      setMobileProducts,
      setMobileProductsForSearch,
      setFixeProducts,
      setInternetProducts,
      setTvProducts,
      setBundlesProducts,
    } = this.props;
    products.getProducts()
      .then((res) => {
        if (res) {

          let mobileProducts = []
          let fixeProducts = []
          let internetProducts = []
          let tvProducts = []
          let bundlesProducts = []
          setProducts(res.body.data.userProducts);
          forEach(res.body.data.userProducts, (product) => {
            reverse(product.Options)
            if (mobileCategories.includes(product.Data.category)) {
              mobileProducts.push(product)
            } else if (product.Data.category === 'FIXE') {
              fixeProducts.push(product)
            } else if (product.Data.category === 'INTERNET') {
              internetProducts.push(product)
            } else if (product.Data.category === 'TV') {
              tvProducts.push(product)
            } else if (product.Data.category === 'BUNDLES') {
              bundlesProducts.push(product)
            }
          })
          setMobileProducts(mobileProducts);
          setMobileProductsForSearch(mobileProducts);
          setFixeProducts(fixeProducts)
          setInternetProducts(internetProducts);
          setTvProducts(tvProducts);
          setBundlesProducts(bundlesProducts);
          this.props.loadServices();

        }
      });
  }
  handleChange(res) {
    const { mobileProducts, setMobileProductsForSearch } = this.props;
    const result = res.target.value.replace(/[<>()+,-]/g, '');
    let pro = []
    forEach(mobileProducts, (product) => {
      const phone = PhoneNumberFormat(product.Data.phoneNumber).replace(/[<>()+,-]/g, '');
      if (phone.includes(result)) {
        pro.push(product)
      }
    })
    setMobileProductsForSearch(pro)
  }
  render() {
    const { translate, searchMobileProducts, isLoaded } = this.props;

    const pendingMobileItems = searchMobileProducts.filter(product => product.Data.isPendingActivation && product.Data.isActive)
    const activeMobileItems = searchMobileProducts.filter(product => (product.Data.isActive || product.Data.hasOngoingTransfer) && !product.Data.isPendingActivation && !product.Data.isPendingUpgrade)
    const inactiveMobileItems = searchMobileProducts.filter(product => !product.Data.isActive && !product.Data.isPendingActivation && !product.Data.cantBeDisplayInInactiveLines)

    return (
      <div className="service">
        <h1 className="title">{translate('mobile')}</h1>
        <div className="form-group">
          <input className="form-control" type="text" placeholder={this.props.translate('search-line')} onChange={this.handleChange} />
        </div>
        {pendingMobileItems ?
          <div>
            <h3 className="service-section-title">
              <span>{translate('pending-activation')}</span>
              <i className="material-icons ng-binding collapsed rotate-icon" data-toggle="collapse" data-target="#pending" aria-expanded="false" >
                keyboard_arrow_down
              </i>
            </h3>
            <div id="pending" className="collapse show">
              <MobileLineList key={1} mobileLines={
                pendingMobileItems
              } />
            </div>
          </div>
          : ''}
        <div>
          <h3 className="service-section-title">
            <span>{translate('activeMobileItems')}</span>
            <i className="material-icons ng-binding rotate-icon" data-toggle="collapse" data-target="#active" aria-expanded="false" >
              keyboard_arrow_down
            </i>
          </h3>
          <div id="active" className="collapse show">
            {isLoaded ? activeMobileItems ? <MobileLineList key={1} mobileLines={activeMobileItems} /> : NoService(translate) : Loading()}
          </div>
        </div>
        {inactiveMobileItems ?
          <div>
            <h3 className="service-section-title">
              <span>{translate('inactives')}</span>
              <i className="material-icons ng-binding collapsed" data-toggle="collapse" data-target="#inactive" aria-expanded="false" >
                keyboard_arrow_down
              </i>
            </h3>
            <div id="inactive" className="collapse">
              <MobileLineList key={1} mobileLines={
                inactiveMobileItems
              } />
            </div>
          </div>
          : ''}
      </div>
    );
  }
}

const viewMapStateToProps = (state) => {
  return {
    products: state.Products.products,
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    searchMobileProducts: state.Products.searchMobileProducts,
    mobileProducts: state.Products.mobileProducts,
    isLoaded: state.User.isLoaded,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setProducts: (products) => {
      dispatch(
        {
          type: 'SET_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProducts: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProductsForSearch: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS_FOR_SEARCH',
          products: products,
        },
      );
    },
    setFixeProducts: (products) => {
      dispatch(
        {
          type: 'SET_FIXE_PRODUCTS',
          products: products,
        },
      );
    },
    setInternetProducts: (products) => {
      dispatch(
        {
          type: 'SET_INTERNET_PRODUCTS',
          products: products,
        },
      );
    },
    setBundlesProducts: (products) => {
      dispatch(
        {
          type: 'SET_BUNDLES_PRODUCTS',
          products: products,
        },
      );
    },
    setTvProducts: (products) => {
      dispatch(
        {
          type: 'SET_TV_PRODUCTS',
          products: products,
        },
      );
    },
    loadServices: () => {
      dispatch({
        type: 'LOAD_SERVICES_INFO',
        isLoaded: true,
      });
    },
  }
}

MobileLine = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(MobileLine);

export default MobileLine;



// WEBPACK FOOTER //
// ./src/components/MyServices/MobileLine.js